import { configureStore } from '@reduxjs/toolkit';
import { composeWithDevTools } from '@redux-devtools/extension';
import cbcAuthorizationSlice from '../reducers/cbcAuthorizationSlice';
import cbcWorkoutSlice from '../reducers/cbcWorkoutSlice';
import activityScoresSlice from '../reducers/cbcActivityScoresSlice';
import cbcStreakSlice from '../reducers/cbcStreakSlice';
import cbcAccountActions from '../reducers/cbcAccountActionsSlice';
import cbcActivityActions from '../reducers/cbcActivityActionsSlice';
import cbcLoggingSlice from '../reducers/cbcLoggingSlice';
import cbcActivitiesSlice from '../reducers/cbcActivitiesSlice';
import pvtFocusStateSlice from '../reducers/pvtFocusStateSlice';
import pvtDeepLinkManagerSlice from "../reducers/pvtDeepLinkManager";
import reminderActionsSlice from "../reducers/cbcReminderMessagesSlice";
export const store = configureStore({
  reducer: {
    cbcAuthorization: cbcAuthorizationSlice,
    cbcWorkout: cbcWorkoutSlice,
    activityScores: activityScoresSlice,
    streakDates: cbcStreakSlice,
    accountActions: cbcAccountActions,
    activityActions: cbcActivityActions,
    cbcLogging: cbcLoggingSlice,
    cbcActivities: cbcActivitiesSlice,
    pvtFocusState: pvtFocusStateSlice,
    pvtDeepLinkManager: pvtDeepLinkManagerSlice,
    reminderActions: reminderActionsSlice
  },
  enhancer: composeWithDevTools(),
});
